import React from "react";
import { motion } from "framer-motion";
import { AlertCircle } from "lucide-react";
import { useLang } from "../context/LanguageContext";

export default function Attention() {
  const { t } = useLang();
  return (
    <section
      className="relative py-20 md:py-28 px-6 md:px-12 overflow-hidden"
      data-testid="attention-section"
    >
      <div
        className="brush-blob bg-burgundy/25"
        style={{
          width: 360,
          height: 360,
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
        }}
      />
      <div className="max-w-3xl mx-auto text-center relative">
        <motion.div
          initial={{ opacity: 0, scale: 0.6, rotate: -8 }}
          whileInView={{ opacity: 1, scale: 1, rotate: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
          className="inline-flex items-center justify-center w-14 h-14 rounded-full border border-burgundy/30 mb-6"
        >
          <AlertCircle size={22} className="text-burgundy" />
        </motion.div>
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.9 }}
          className="text-xs uppercase tracking-[0.4em] text-burgundy mb-4"
        >
          {t.attention.overline}
        </motion.p>
        <motion.h2
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 1.1, delay: 0.1 }}
          className="font-script text-5xl md:text-7xl text-burgundy mb-8 leading-none"
          data-testid="attention-title"
        >
          {t.attention.title}
        </motion.h2>
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 1.1, delay: 0.25 }}
          className="font-serif italic text-xl md:text-2xl text-ink/80 leading-relaxed max-w-2xl mx-auto"
          data-testid="attention-body"
        >
          {t.attention.body}
        </motion.p>
      </div>
    </section>
  );
}
